import { CriterioTipoDado } from '@shared/criterio';

/** Cards */
export const DashboardCardTipo = {
  LISTA: 'l',
  GRAFICO_COLUNA: 'gc',
  GRAFICO_LINHA: 'gl',
  GRAFICO_PIZZA: 'gp',
  TOTALIZADOR: 't',
} as const;
export type DashboardCardTipoType =
  (typeof DashboardCardTipo)[keyof typeof DashboardCardTipo];

export type DashboardCardModel = {
  id: string;
  titulo: string;
  tipo: DashboardCardTipoType;
  dimensoes: {
    id: string;
    tipoDado: CriterioTipoDado;
    dadosAdicionais: string[];
  }[];
  valores: string[];
  dados?: DashboardDadoModel;
};

/** Dados */
export type DashboardDadoModel = {
  id: string;
  dimensoes: {
    id: string;
    tipoDado: CriterioTipoDado;
  }[];
  valores: string[];
  itens: DashboardDadoCardItemModel[];
  itensHistorico: DashboardDadoCardItemModel[];
};

export type DashboardDadoCardItemModel = Record<string, any>;
